export default "__VITE_ASSET__DN8rr8iv__"